import uButton from './uButton';
import omniButton from './omniButton';

export { uButton, omniButton };




// WEBPACK FOOTER //
// ./src/components/uButton/index.js